import React, { useEffect, useMemo, useState } from "react";
import { Box, Paper, Typography } from "@mui/material";
import { useClub } from "../../contexts/ClubContext";

const QUOTES = [
  "Success isn't owned, it is rented and the rent is due everyday",
  "Most people miss their opportunity because it was dressed up in overalls and looked like work.",
];

export const MobileHome: React.FC = () => {
  const { club } = useClub();
  const [quoteIndex, setQuoteIndex] = useState(0);

  const quotes = useMemo(() => QUOTES, []);

  useEffect(() => {
    const interval = window.setInterval(() => {
      setQuoteIndex((prev) => (prev + 1) % quotes.length);
    }, 7000);

    return () => window.clearInterval(interval);
  }, [quotes.length]);

  return (
    <Box sx={{ width: "100%", pt: 2, display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          minHeight: 140,
          alignItems: "center",
        }}
      >
        {club?.profile_picture ? (
          <Box
            component="img"
            src={club.profile_picture}
            alt={`${club.name} logo`}
            sx={{
              maxWidth: 220,
              width: "70%",
              height: "auto",
              objectFit: "contain",
            }}
          />
        ) : (
          <Typography variant="h6" align="center">
            {club?.name || "Club"}
          </Typography>
        )}
      </Box>

      <Paper
        elevation={3}
        sx={{
          width: "100%",
          p: 2.5,
          borderRadius: 2,
          minHeight: 140,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <Typography variant="body1" sx={{ fontStyle: "italic" }}>
          "{quotes[quoteIndex]}"
        </Typography>
      </Paper>
    </Box>
  );
};
